import { HttpClientResponse, QueryParameters, RequestHeaders } from './Definitions';
import { RegionalSubdomainExecutor } from './RegionalSubdomainExecutor';

// MaltRequestExecutor uses cookies on the devsite domain for authentication
export default class MaltRequestExecutor<T extends string> extends RegionalSubdomainExecutor<T> {
  protected execute(
    url: string,
    params: Partial<RequestInit>,
    headers?: RequestHeaders,
    queryParams?: QueryParameters
  ): Promise<HttpClientResponse> {
    return super.execute(
      url,
      params,
      headers,
      queryParams,
      { credentials: 'include' } // include this so that devsite cookies are sent to malt
    );
  }
}
